import React, { useContext, useState, useMemo, useCallback } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import { str_isEmpty } from '@Util/Utils';

import Content_Container from '@Elements/Content_Container';
import { Icon_Edit } from '@Elements/ImageElements/Icons';
import Edit_Bulletin_Popup from '@Modules/Popups/Edit_Bulletin_Popup';

export default function Bulletin_Board_Module(): JSX.Element {
    const { t } = useTranslation();
    const {
        bulletin_board,
        fetch_bulletin_board
    }: context_type = useContext(Context);
    const [edit_bulletin_board, set_edit_bulletin_board] = useState<boolean>(false);

    const handleEditButtonClick = useCallback(() => {
        fetch_bulletin_board();
        set_edit_bulletin_board(true);
    }, []);

    const bulletinContent = useMemo(() => {
        return !str_isEmpty(bulletin_board) ? (
            <p className="Normal">{bulletin_board}</p>
        ) : (
            <p className="Normal">{t('Text.NoBulletinBoardToShow')}</p>
        );
    }, [bulletin_board, t]);

    return (
        <section className="Module Bulletin_Board">
            <header className="Module_Header Module_Header--FullWidth Module_Header--WithButton">
                <h2 className="Headline2">{t('Text.BulletinBoard')}</h2>
                <button
                    type="button"
                    className="Button Button_Icon"
                    aria-label={t('Aria.EditBulletinBoard')}
                    title={t('Aria.EditBulletinBoard')}
                    onClick={handleEditButtonClick}
                    aria-expanded={edit_bulletin_board}
                >
                    <Icon_Edit />
                </button>
            </header>
            <Content_Container>
                {bulletinContent}
            </Content_Container>
            <Edit_Bulletin_Popup
                open={edit_bulletin_board}
                set_open={set_edit_bulletin_board}
            />
        </section>
    );
}